import { Summary } from '@atom/types/work';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import ReportSection from './ReportSection';

import classes from './workOrderReport.module.css';

interface Props {
  summary: Summary[];
}

const SummarySection = ({ summary }: Props) => {
  const showSummarySection = !isNilOrEmpty(summary);

  return showSummarySection ? (
    <ReportSection title="Summary">
      <div className={classes.summarySection}>
        {summary.map(item => (
          <div className={classes.summaryItem}>
            <div className={classes.summaryTitle}>{item.title}</div>
            <div>{item.contents}</div>
          </div>
        ))}
      </div>
    </ReportSection>
  ) : (
    <div />
  );
};

export default SummarySection;
